// VoiceStudio.jsx — Unified Voice Studio
// Merges the Quick Clone wizard (Phase 3A) and the Advanced Studio (Phase 6)
// into a single page with two tabs.

import React, { useState } from 'react';
import { Mic, Sparkles, FlaskConical } from 'lucide-react';
import TopBar from '../components/TopBar.jsx';
import VoiceCloning from './VoiceCloning.jsx';
import VoiceCloningStudio from './VoiceCloningStudio.jsx';

const TABS = [
  {
    id: 'quick',
    label: 'Quick Clone',
    icon: Sparkles,
    desc: 'Record a short script and create your AI voice in minutes.',
  },
  {
    id: 'advanced',
    label: 'Advanced Studio',
    icon: FlaskConical,
    desc: 'Upload real call recordings, isolate the agent, A/B compare, attach to bots.',
  },
];

export default function VoiceStudio() {
  const [tab, setTab] = useState('quick');
  const active = TABS.find((t) => t.id === tab) || TABS[0];

  return (
    <div className="space-y-4">
      <TopBar
        title="Voice Studio"
        subtitle="AI Dialer · Create and manage your AI voice"
      />

      {/* Tab switcher */}
      <div className="panel p-2">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {TABS.map((t) => {
            const Icon = t.icon;
            const isActive = t.id === tab;
            return (
              <button
                key={t.id}
                onClick={() => setTab(t.id)}
                className={`flex items-start gap-3 p-3 rounded-lg border text-left transition ${
                  isActive
                    ? 'bg-civix-purple/15 border-civix-purple/50'
                    : 'bg-white/2 border-white/10 hover:bg-white/5'
                }`}
              >
                <div
                  className={`p-2 rounded-md ${
                    isActive ? 'bg-civix-purple/30' : 'bg-white/5'
                  }`}
                >
                  <Icon
                    className={`w-4 h-4 ${
                      isActive ? 'text-civix-purple' : 'text-white/60'
                    }`}
                  />
                </div>
                <div className="flex-1">
                  <div
                    className={`text-sm font-semibold ${
                      isActive ? 'text-white' : 'text-white/80'
                    }`}
                  >
                    {t.label}
                  </div>
                  <div className="text-xs text-white/50 mt-0.5">{t.desc}</div>
                </div>
              </button>
            );
          })}
        </div>
      </div>

      {/* Active panel */}
      {tab === 'quick' && <VoiceCloning embedded />}
      {tab === 'advanced' && <VoiceCloningStudio embedded />}
    </div>
  );
}
